import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RaisedButton, Table, TableBody, TableHeader, TableRow, TableHeaderColumn, TableRowColumn } from 'material-ui';

import styles from "styles";
import { getListDomain } from 'actions/domains';
import DomainDelete from './Delete';
import DomainConnect from './Connect';

class Domains extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenDeleteDialog: false,
            isOpenConnectDialog: false,
            selectedItemToDelete: '',
        };

        this.toggleDeleteDialog = this.toggleDeleteDialog.bind(this);
        this.toggleConnectDialog = this.toggleConnectDialog.bind(this);
    }

    componentDidMount() {
        this.props.getListDomain();
    }

    toggleDeleteDialog(id = '') {
        this.setState({
            isOpenDeleteDialog: !this.state.isOpenDeleteDialog,
            selectedItemToDelete: id,
        });
    }

    toggleConnectDialog() {
        this.setState({
            isOpenConnectDialog: !this.state.isOpenConnectDialog,
        });
    }

    render() {
        const { isOpenDeleteDialog, isOpenConnectDialog, selectedItemToDelete, } = this.state;
        const { domains } = this.props;

        return (
            <div id='domains-page' className='container'>
                <DomainDelete
                    id={selectedItemToDelete}
                    toggle={this.toggleDeleteDialog}
                    isOpen={isOpenDeleteDialog}
                />
                <div className='container'>
                    <h2>
                        Domains
                    </h2>
                    <div className="paper-block margin-10">
                        <div className="row">
                            <div className="col-xs-6 middle-xs" style={{display: 'flex'}}>
                                <DomainConnect
                                    isOpen={isOpenConnectDialog}
                                    toggle={this.toggleConnectDialog}
                                />
                            </div>
                        </div>
                    </div>

                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    domain
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    user
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    added at
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>

                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>



                        <TableBody displayRowCheckbox={false}>
                            {
                                domains.items.map((item, index) => {
                                    return (<TableRow key={index}>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            { item.domain }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            {
                                             item.user
                                                 ? `${item.user.name} ${item.user.surname} ${item.user.email}`
                                                 : '-'
                                            }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            { item.addedAt }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            <RaisedButton
                                                label='Delete'
                                                secondary
                                                onClick={() => this.toggleDeleteDialog(item._id)}
                                            />
                                        </TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ domains }) => {
        return {
            domains,
        };
    },
    dispatch => bindActionCreators({
            getListDomain
    },
    dispatch),
)(Domains);



// WEBPACK FOOTER //
// ./app/components/Domains/Page.jsx